
const m = window.require("@ember/controller");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
